<script>
import { merchantComputed } from '@state/helpers'
import formatDate, { formatLunar } from '@utils/format-date'
import { parseStringToDateTime } from '@utils/parse-string-to-date'
import formatOrderStatus from '@utils/format-order-status'
import formatProductType from '@utils/format-product-type'

import formatOrderGoogleCalendarUrl from '@utils/format-order-google-calendar-url'

export default {
  filters: {
    formatDate,
    formatLunar,
  },
  props: {
    orders: {
      type: Array,
      required: true,
    }
  },
  computed: {
    ...merchantComputed,
  },
  methods: {
    formatOrderStatus,
    formatProductType,
    formatOrderGoogleCalendarUrl,
    handleCancel(order) {
      const vnodes = [];

      if (order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {order.merchant.email}
      </a>
      )
      }

      if (order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(
        messageElement,
        this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_TITLE',
          {
            actionName: this.$t(
              `product.${order.productType}.ORDER_CANCEL`
            ),
            merchantName: order.merchant.name,
          } /* 取消結緣請聯繫{merchantName} */
        ),
        {
          distinguishCancelAndClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t(
            'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
          ),
          confirmButtonClass: 'button is-primary is-rounded',
        }
      )
    },
    handleContact(order) {
      const vnodes = []

      if (order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {order.merchant.email}
      </a>
      )
      }

      if (order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(messageElement, this.$t('global.CONTACT_PREFIX', { name: order.merchant.name }/* 聯繫{name} */), {
        distinguishCancelAndClose: false,
        dangerouslyUseHTMLString: true,
        lockScroll: true,
        confirmButtonText: this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
        ),
        confirmButtonClass: 'button is-primary is-rounded',
      })
    },
    orderIsCanPay(order) {
      const isExpired = parseStringToDateTime(order.paymentExpiredDate) <= new Date();

      return !order.paymentExpiredDate || !isExpired
    },
    priceTotal(order) {
      return order.paymentMethod === 'prepaid'
        ? this.$t('global.PAYMENT_METHOD_PREPAID', /* 預付抵用 */)
        : `$${order.priceTotal}`
    },
    formatLink(type, data = {}) {
      switch (type) {
        case 'member-order-item':
          return {
            name: 'member-order-item',
            params: {
              merchantAlias: data.order.merchant.alias,
              orderKey: data.order.id,
            },
            query: {
              language: this.$route.query.language,
            }
          };
        case 'member-order-ticket':
          return {
            name: 'member-order-ticket',
            params: {
              merchantAlias: data.order.merchant.alias,
              orderKey: data.order.id,
            },
            query: {
              language: this.$route.query.language,
            },
          };
        case 'member-order-code':
          return {
            name: 'member-order-code',
            params: {
              merchantAlias: data.order.merchant.alias,
              orderKey: data.order.id,
            },
            query: {
              language: this.$route.query.language,
            },
          };
        case 'checkout-unpaid':
          return {
            name: 'checkout-unpaid',
            params: {
              merchantAlias: data.order.merchant.alias,
              productId: data.order.productAlias,
              orderKey: data.order.id,
            },
            query: {
              language: this.$route.query.language,
            },
          };
        case 'booking-product':
          return {
            name: 'booking-product',
            params: {
              merchantAlias: data.order.merchant.alias,
              productType: data.order.productType,
              productId: data.order.productAlias,
            },
            query: {
              language: this.$route.query.language,
            },
          };
        default:
          return '';
      }
    },
    formatText(type, data = {}) {
      switch (type) {
        case 'date-light':
        case 'date-worshipset':
          return formatLunar(data.order.startDate);
        case 'date-treasury':
        case 'date-pudu':
          return formatDate(data.order.startDate, 'dateSlash');
        case 'date-puja':
          const inventoryTitle = ` ${data.order.inventoryTitle}` || '';

          return `${formatDate(data.order.startDate, 'dateTime')}${inventoryTitle}`;
        default:
            return ''
      }
    }
  },
}
</script>
<template>
  <div>
    <div
      v-for="(orderItem, index) in orders"
      :key="index"
      :class="$style.wrapper"
      class="has-block-link"
    >
      <router-link
        class="is-block-link"
        :to="formatLink('member-order-item', { order: orderItem })"
      ></router-link>
      <div :class="$style.inner">
        <div class="columns is-vcentered is-multiline is-mobile" :class="$style['order-item-mobile']">
          <div class="column is-full-mobile is-two-fifths-tablet" :class="$style['order-item-mobile-full']">
            <div>
              <div style="margin-bottom: 0.5rem">
                <div class="level is-size-medium">
                  <div class="level-left">
                    <b-tag
                      :type="`is-status-${formatOrderStatus('alias', orderItem.status)}`"
                      rounded
                      style="margin-right: 0.5rem">
                      {{ formatOrderStatus('text', orderItem.status, orderItem.paymentMethod) }}
                    </b-tag>
                    {{ orderItem.productName }}
                  </div>
                </div>
              </div>
              <p class="has-text-grey is-text-content">
                {{ orderItem.merchant.name }}
                <br>{{ $t(`product.${orderItem.productType}.TITLE_TIME`/*活動時間*/) }}：{{ formatText(`date-${orderItem.productType}`, { order: orderItem }) }}
              </p>
            </div>
          </div>
          <div class="column is-half-mobile" :class="$style['order-item-mobile-half']">
            <div>
              <span class="is-size-6">{{ priceTotal(orderItem) }}</span>
            </div>
          </div>
          <div class="column is-half-mobile is-narrow-tablet">
            <div>
              <span  class="has-text-grey">{{ $t('global.ORDER_CREATED'/*結緣成立時間*/) }}</span>
              <br><span :class="$style.orderStart">{{ orderItem.created | formatDate('dateSlash') }}</span>
            </div>
          </div>
          <div class="column is-full-mobile is-narrow-tablet">
            <div class="buttons is-right">
              <template>
                <router-link
                  v-if="formatOrderStatus('alias', orderItem.status) === 'paid' && formatProductType('category', orderItem.productType) === 'activity'"
                  class="button is-primary is-rounded fix-width-167"
                  :to="formatLink('member-order-ticket', { order: orderItem })"
                >
                  {{ $t('global.QRCODE'/* 使用 QR Code */) }}
                </router-link>
                <router-link
                  v-else-if="formatOrderStatus('alias', orderItem.status) === 'complete' && formatProductType('category', orderItem.productType) === 'light'"
                  class="button is-primary is-rounded fix-width-167"
                  :to="formatLink('member-order-code', { order: orderItem })"
                >
                  {{ $t('global.LIGHT_DETAIL'/*點燈明細*/) }}
                </router-link>
                <router-link
                  v-else
                  class="button is-primary is-rounded is-outlined fix-width-167"
                  :to="formatLink('member-order-item', { order: orderItem })"
                >
                  {{ $t('global.MEMBER_ORDER_VIEW_DETAIL'/*查看結緣詳情*/) }}
                </router-link>
              </template>
              <b-dropdown aria-role="list" position="is-bottom-left">
                <b-button
                  slot="trigger"
                  type="is-primary is-circle is-outlined"
                >
                  <BaseIcon name="ellipsis-h" />
                </b-button>
                <template v-if="formatOrderStatus('alias', orderItem.status) === 'unpaid'">
                  <b-dropdown-item
                    v-if="orderIsCanPay(orderItem) && !orderItem.paymentMethod"
                    aria-role="listitem"
                    has-link
                  >
                    <router-link
                      :to="formatLink('checkout-unpaid', { order: orderItem })"
                    >
                      {{ $t('global.PAYMENT_NOW'/* 前往付款 */) }}
                    </router-link>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    has-link
                  >
                    <router-link
                      :to="formatLink('booking-product', { order: orderItem })"
                    >
                      {{ $t(`product.${orderItem.productType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
                    </router-link>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="handleContact(orderItem)"
                  >
                    {{ $t('global.CONTACT_MERCHANT'/*聯絡宮廟*/) }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="handleCancel(orderItem)"
                  >
                    {{ $t(`product.${orderItem.productType}.ORDER_CANCEL`/* 取消結緣 */) }}
                  </b-dropdown-item>
                </template>
                <template v-if="formatOrderStatus('paid', orderItem.status)">
                  <template>
                    <b-dropdown-item
                      v-if="orderItem.status !== 1 && formatProductType('category', orderItem.productType) === 'activity'"
                      aria-role="listitem"
                      has-link
                    >
                      <router-link
                        :to="formatLink('member-order-ticket', { order: orderItem })"
                      >
                        {{ $t('global.ADMISSION_QRCODE'/* 使用 QR Code */) }}
                      </router-link>
                    </b-dropdown-item>
                  </template>
                  <b-dropdown-item
                    v-if="formatProductType('category', orderItem.productType) === 'activity'"
                    aria-role="listitem"
                    has-link
                  >
                    <a
                      target="_blank"
                      :href="formatOrderGoogleCalendarUrl(orderItem)"
                    >
                      {{ $t('global.ADD_CALENDAR'/* 加入行事曆 */) }}
                    </a>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    has-link
                  >
                    <router-link
                      :to="formatLink('booking-product', { order: orderItem })"
                    >
                      {{ $t(`product.${orderItem.productType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
                    </router-link>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="handleContact(orderItem)"
                  >
                    {{ $t('global.CONTACT_MERCHANT'/*聯絡宮廟*/) }}
                  </b-dropdown-item>
                </template>
                <template v-if="formatOrderStatus('alias', orderItem.status) === 'cancel'">
                  <b-dropdown-item
                    aria-role="listitem"
                    has-link
                  >
                    <router-link
                      :to="formatLink('booking-product', { order: orderItem })"
                    >
                      {{ $t(`product.${orderItem.productType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
                    </router-link>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="handleContact(orderItem)"
                  >
                    {{ $t('global.CONTACT_MERCHANT'/*聯絡宮廟*/) }}
                  </b-dropdown-item>
                </template>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .wrapper {
    cursor: pointer;
    .inner {
      padding: 1.5rem 0;
      margin: 0 1.5rem;
      .orderItemMobile{
        @include mobile{
          flex-direction: column;
          align-items: start;
        }
      }
    }
    &:hover {
      box-shadow: 0 0 15px 0 rgba(178,180,181,.3);
      transition: box-shadow .3s;
    }
    &:not(:last-child) {
      .inner {
        border-bottom: 1px solid $color-border-base;
      }
    }
  }
</style>
